module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.72993ddd.woff2";